import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDeleteAccount } from '../hooks/useProfile'
import { Button } from '@/components/ui/Button'
import { Alert } from '@/components/ui/Alert'
import { useTranslation, Trans } from 'react-i18next'



export function DangerZone() {
  const { t } = useTranslation()
  const confirmWord = t('profile.delete_confirm_word')
  const [isOpen, setIsOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [apiError, setApiError] = useState<string | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const { mutate: deleteAccount, isPending } = useDeleteAccount()

  const handleOpen = () => {
    setIsOpen(true)
    setInputValue('')
    setApiError(null)
    setTimeout(() => inputRef.current?.focus(), 50)
  }

  const handleClose = () => {
    setIsOpen(false)
    setInputValue('')
  }

  const handleDelete = () => {
    setApiError(null)
    deleteAccount(undefined, {
      onSuccess: () => navigate('/auth/login', { replace: true }),
      onError: () => setApiError(t('profile.retry_error')),
    })
  }

  return (
    <div className="rounded-xl border border-mindeia-error bg-mindeia-error-light p-5">
      <h2 className="text-base font-semibold text-mindeia-error mb-1">{t('profile.danger_title')}</h2>
      <p className="text-sm text-neutral-700 mb-4">
        {t('profile.danger_hint')}
      </p>

      {!isOpen ? (
        <Button
          variant="ghost"
          onClick={handleOpen}
          className="min-h-[44px] border border-mindeia-error text-mindeia-error hover:bg-mindeia-error-light"
        >
          {t('profile.delete_account')}
        </Button>
      ) : (
        <div className="flex flex-col gap-3">
          <p className="text-sm font-medium text-neutral-800">
            <Trans
              i18nKey="profile.delete_type_word"
              values={{ word: confirmWord }}
              components={[<strong key="word" />]}
            />
          </p>
          <input
            ref={inputRef}
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={confirmWord}
            aria-label={t('profile.delete_input_label')}
            className="min-h-[44px] rounded-md border border-mindeia-error bg-white px-3 py-2 text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-mindeia-error"
          />
          {apiError && <Alert variant="error">{apiError}</Alert>}
          <div className="flex gap-3">
            <Button type="button" variant="secondary" onClick={handleClose} className="flex-1">
              {t('common.cancel')}
            </Button>
            <Button
              type="button"
              isLoading={isPending}
              disabled={inputValue !== confirmWord}
              onClick={handleDelete}
              className="flex-1 bg-mindeia-error text-white hover:bg-red-700 border-transparent min-h-[44px]"
            >
              {t('profile.delete_forever')}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
